import type { AnchorHTMLAttributes } from 'react'
import { cn } from '@/utilities/ui'

type SupportEmailLinkProps = Readonly<
  { email: string } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>
>

export function SupportEmailLink({
  email,
  className,
  children,
  'data-testid': dataTestId = 'support-email-link',
  ...anchorProps
}: SupportEmailLinkProps & { 'data-testid'?: string }) {
  return (
    <a
      {...anchorProps}
      href={`mailto:${email}`}
      className={cn('text-tenant-hyperlink break-all underline', className)}
      data-testid={dataTestId}
    >
      {children ?? email}
    </a>
  )
}
